module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/inactive-dormand/inactive-dormand.component.css
// module id = ./src/app/accountmaster/inactive-dormand/inactive-dormand.component.css
// module chunks = main